import InquiryListContainer from './InquiryListContainer';
export default InquiryListContainer;
